import React, { useState } from "react";
import { AxiosResponse } from "axios";
import { getRequest } from "../../../../utils/httpRequest";
import CoursesModal from "./CoursesModal";

interface Props {
  className?: string;
  // "Still not sure where to start?" only lands with someone who has not
  // started anything. Callers who know the learner is already under way pass
  // their own heading.
  heading?: string;
  userIsInUk: boolean;
}

const AiCoursePicker: React.FC<Props> = ({
  className,
  heading,
  userIsInUk,
}) => {
  const [role, setRole] = useState("");
  const [goal, setGoal] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [courses, setCourses] = useState([]);
  const [commentary, setCommentary] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const isFormValid = role.trim().length >= 2 && goal.trim().length >= 3;

  const onSubmit = (e) => {
    e.preventDefault();

    if (!isFormValid) {
      return;
    }

    setLoading(true);
    setOpenModal(true);

    const params = new URLSearchParams({
      role: role.trim(),
      goal: goal.trim(),
    });

    getRequest(`/api/ai/courses/recommender?${params.toString()}`)
      .then((response: AxiosResponse) => {
        setCommentary(response.data.commentary);
        setCourses(response.data.courses);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error.response?.statusText);

        setLoading(false);
        setCommentary("");
        setCourses([]);
      });
  };

  const onClickCloseModal = () => {
    setRole("");
    setGoal("");
    setOpenModal(false);
    setErrorMessage("");
    setCourses([]);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onSubmit(e);
    }
  };

  return (
    <div className="">
      <section className="picker-section" aria-labelledby="picker-title">
        <div className="container">
          <div className="picker-card">
            <h2 id="picker-title">
              {heading || "Still not sure where to start?"}
            </h2>
            <p className="picker-sub">
              Tell us who you are and what you're after. We'll do the
              matchmaking.
            </p>
            <div className="picker-form">
              <span className="picker-label">I am a</span>
              <input
                type="text"
                value={role}
                id="picker-role"
                name="role"
                autoComplete="organization-title"
                placeholder="e.g. marketer, founder"
                onChange={(e) => setRole(e.target.value)}
                onKeyDown={handleKeyPress}
                required={true}
              />
              <label className="picker-label" htmlFor="picker-goal">
                looking to
              </label>
              <input
                type="text"
                value={goal}
                id="picker-goal"
                name="goal"
                placeholder="e.g. think more clearly about marketing"
                required={true}
                onChange={(e) => setGoal(e.target.value)}
                onKeyDown={handleKeyPress}
              />
              <button
                type="submit"
                className="btn-find"
                disabled={!isFormValid}
                onClick={onSubmit}
              >
                Find my course &rarr;
              </button>
            </div>
          </div>
        </div>
      </section>
      <CoursesModal
        openModal={openModal}
        onClickCloseModal={onClickCloseModal}
        commentary={commentary}
        courses={courses}
        errorMessage={errorMessage}
        loading={loading}
        roleText={role}
        goalText={goal}
        userIsInUk={userIsInUk}
      />
    </div>
  );
};

export default AiCoursePicker;
